import styled from 'styled-components';

import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';

export const Card: any = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;

  box-shadow: 0px 6px 10px rgba(128, 98, 96, 0.16);
  border-radius: 12px;
  padding: 16px;
  margin: 16px 0;
`;

export const Title = styled.h4`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  color: #332927;
`;

export const Header = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 10px;
  align-items: center;
  justify-content: space-between;
  color: #332927;
`;

export const Arrow = styled(Chevron)`
  width: 12px;
  height: 12px;
  padding: 0 2px;
  box-sizing: content-box;
  color: #626e75;
  transform: rotate(90deg);

  &.active {
    transform: rotate(270deg);
  }
`;

export const Container = styled.div`
  & > div {
    border-bottom: solid 1px ${({ theme }) => theme.flightDetails.cancellationPolicies.cardContent};

    &:last-child {
      border: 0;
    }
  }
`;

export const Content: any = styled.div`
  padding: 16px 0;

  & p {
    margin: 8px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const FlightTitle = styled.h5`
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 140%;
  font-weight: 600;
  color: #332927;
`;

export const FlightPolicy = styled.span`
  display: unset;
  font-size: 12px;
  font-weight: 600;
  line-height: 130%;
  color: #332927;
`;

export const FlightPolicyValue = styled.span`
  display: unset;
  font-size: 12px;
  line-height: 130%;
  color: #332927;
`;

export const Disclaimer = styled.div`
  font-size: 10px;
  line-height: 1.4;
  margin: 16px 0 0;
  color: #706967;
`;
